<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Assurance Loueur de Véhicules - Location Auto</h2>
    <p>
      Si vous êtes à la recherche de ce type d'<strong>assurance Loueur de Véhicules</strong>, merci de prendre contact avec nous car il existe trop de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Qui a besoin d'une assurance loueur de véhicules ?</h2>
    <p>
      Cette assurance spécifique s'adresse aux professionnels de la location de véhicules :
    </p>
    <ul>
      <li>Agences de location de voitures</li>
      <li>Sociétés de location de véhicules utilitaires</li>
      <li>Loueurs de véhicules de prestige ou de luxe</li>
      <li>Auto-écoles</li>
      <li>Entreprises de location courte ou longue durée</li>
      <li>Plateformes de location entre particuliers (professionnalisées)</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Les risques spécifiques des loueurs de véhicules</h2>
    <p>
      L'activité de location de véhicules présente des risques particuliers qui nécessitent une couverture adaptée :
    </p>
    <ul>
      <li><strong>Dommages causés par les locataires :</strong> Accidents, rayures, chocs lors de la location</li>
      <li><strong>Vol de véhicules :</strong> Vol ou tentative de vol pendant la période de location</li>
      <li><strong>Fraude :</strong> Utilisation de faux documents, non-restitution des véhicules</li>
      <li><strong>Responsabilité civile :</strong> Dommages causés à des tiers par vos véhicules de location</li>
      <li><strong>Perte d'exploitation :</strong> Immobilisation de véhicules après un sinistre</li>
      <li><strong>Litiges avec les locataires :</strong> Contestations sur l'état du véhicule, franchises</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>Les garanties indispensables</h2>
    
    <h3>Responsabilité Civile Professionnelle</h3>
    <p>
      <strong>Obligatoire</strong> pour tous les loueurs de véhicules. Cette garantie couvre les dommages matériels et corporels causés à des tiers dans le cadre de votre activité de location.
    </p>

    <h3>Assurance Flotte Automobile</h3>
    <p>
      Couverture de l'ensemble de vos véhicules de location. Cette assurance peut inclure :
    </p>
    <ul>
      <li>Dommages tous accidents (même si le locataire est responsable)</li>
      <li>Vol et incendie</li>
      <li>Bris de glace</li>
      <li>Assistance 24h/24 et véhicule de remplacement</li>
      <li>Protection juridique en cas de litige</li>
    </ul>

    <h3>Garantie Dommages</h3>
    <p>
      Protection contre les dommages causés aux véhicules pendant la période de location, incluant :
    </p>
    <ul>
      <li>Accidents de la circulation</li>
      <li>Rayures et impacts</li>
      <li>Dommages au véhicule lors de manœuvres</li>
      <li>Vandalisme</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Garanties complémentaires recommandées</h2>
    
    <h3>Protection du chiffre d'affaires</h3>
    <p>
      Indemnisation de la perte de revenus en cas d'immobilisation prolongée de vos véhicules suite à un sinistre.
    </p>

    <h3>Garantie Vol avec agression</h3>
    <p>
      Couverture spécifique en cas de vol du véhicule avec violence ou menace envers le locataire ou vos employés.
    </p>

    <h3>Protection juridique renforcée</h3>
    <p>
      Prise en charge des frais de justice en cas de litige avec un locataire concernant :
    </p>
    <ul>
      <li>Les dommages non restitués</li>
      <li>Les contestations de franchises</li>
      <li>Les fraudes documentaires</li>
      <li>Les non-paiements</li>
    </ul>

    <h3>Couverture des accessoires et équipements</h3>
    <p>
      Protection des équipements additionnels : GPS, sièges bébé, porte-skis, coffres de toit, etc.
    </p>

    <h3>Garantie Contenu des locaux professionnels</h3>
    <p>
      Assurance de vos bureaux, agences, ateliers contre l'incendie, le vol, les dégâts des eaux.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Cas particulier : les auto-écoles</h2>
    <p>
      Les auto-écoles ont des besoins spécifiques en matière d'assurance :
    </p>
    <ul>
      <li><strong>RC Professionnelle moniteur :</strong> Obligatoire pour chaque moniteur</li>
      <li><strong>Assurance des véhicules double commande :</strong> Adaptée aux risques liés à l'apprentissage</li>
      <li><strong>Garantie conducteur élève :</strong> Protection en cas d'accident causé par un élève conducteur</li>
      <li><strong>Protection des locaux :</strong> Bureaux, salles de code, véhicules en stationnement</li>
      <li><strong>Cyber-assurance :</strong> Protection des données personnelles des élèves (RGPD)</li>
    </ul>
    
    <p><strong>Bon à savoir :</strong></p>
    <p>
      Les contrats d'assurance pour auto-écoles incluent généralement des clauses spécifiques concernant l'âge et l'expérience des élèves conducteurs.
    </p>
  </div>

  <div class="content-section">
    <h2>Tarification</h2>
    <p>
      Le coût de votre assurance loueur de véhicules dépend de nombreux critères :
    </p>
    <ul>
      <li>Nombre et type de véhicules dans votre flotte (citadines, SUV, utilitaires, véhicules de luxe)</li>
      <li>Valeur totale du parc automobile</li>
      <li>Usage des véhicules (location courte durée, longue durée, auto-école)</li>
      <li>Profil des locataires (particuliers, professionnels, jeunes conducteurs)</li>
      <li>Historique de sinistralité de votre entreprise</li>
      <li>Mesures de sécurité mises en place (géolocalisation, contrôles renforcés)</li>
      <li>Franchise appliquée aux locataires</li>
      <li>Zone géographique d'activité</li>
    </ul>
    
    <p><strong>Ordre de grandeur :</strong></p>
    <ul>
      <li>Petite agence (5-10 véhicules) : 3 000€ à 8 000€/an</li>
      <li>Agence moyenne (10-30 véhicules) : 8 000€ à 25 000€/an</li>
      <li>Grande structure (30+ véhicules) : À partir de 25 000€/an</li>
      <li>Auto-école (2-5 véhicules) : 2 500€ à 6 000€/an</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Comment réduire vos coûts d'assurance ?</h2>
    <ul>
      <li><strong>Équiper vos véhicules de systèmes de géolocalisation</strong> : Réduction de 5% à 10%</li>
      <li><strong>Mettre en place un contrôle strict des locataires</strong> : Vérification des permis, antécédents</li>
      <li><strong>Former vos équipes à la prévention</strong> : Sensibilisation aux risques de fraude</li>
      <li><strong>Augmenter les franchises</strong> : Réduction de prime mais augmentation du reste à charge</li>
      <li><strong>Maintenir une bonne gestion de la sinistralité</strong> : Bonus/malus avantageux</li>
      <li><strong>Installer des caméras dans les véhicules</strong> : Preuve en cas de litige</li>
      <li><strong>Proposer des assurances complémentaires aux locataires</strong> : Réduction de votre risque</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Pourquoi choisir Brokins pour votre assurance loueur de véhicules ?</h2>
    <ul>
      <li><strong>Expertise du secteur :</strong> Connaissance approfondie des métiers de la location automobile</li>
      <li><strong>Solutions sur mesure :</strong> Contrats adaptés à votre type de location (courte durée, longue durée, luxe, auto-école)</li>
      <li><strong>Réseau d'assureurs spécialisés :</strong> Partenariats avec les meilleurs acteurs du marché</li>
      <li><strong>Tarifs compétitifs :</strong> Négociation des meilleures conditions pour optimiser vos coûts</li>
      <li><strong>Accompagnement sinistre :</strong> Assistance dédiée pour accélérer vos indemnisations</li>
      <li><strong>Conseil en gestion des risques :</strong> Recommandations pour réduire votre sinistralité</li>
    </ul>
  </div>

  <div class="content-section cta-section">
    <h2>Contactez-nous pour votre assurance loueur de véhicules</h2>
    <p>Nos experts vous proposent une solution adaptée à votre activité de location</p>
    <button class="btn-primary" routerLink="/contact">Contactez-nous</button>
  </div>
</app-page-layout>
